<template>
  <div class="GoodsForEmployee_container">
    <div class="GoodsForEmployee_logo"></div>
    <div class="GoodsForEmployee_tab-list">
      <div
        class="GoodsForEmployee_tab-item GoodsForEmployee_tab-item-unactive"
        :class="`GoodsForEmployee_tab-item-${
          index == selectIndex ? 'active' : 'unactive'
        }`"
        v-for="(item, index) in tabList"
        :key="index"
        @click="handleTabClick(index)"
      >
        {{ item }}
      </div>
    </div>
    <div class="GoodsForEmployee_goods-list">
      <div
        class="GoodsForEmployee_goods-item"
        v-for="(item, index) in goods[selectIndex]"
        :key="index"
        @click="handleBuyClick(item.id)"
      >
        <div class="GoodsForEmployee_goods-item-info">
          <img :src="item.img" alt="" class="GoodsForEmployee_goods-item-img" />
          <div
            class="GoodsForEmployee_goods-item-name"
            :class="selectIndex == 0 ? 'one-line' : 'two-line'"
          >
            {{ item.name }}
          </div>
          <div class="GoodsForEmployee_goods-item-sku" v-if="selectIndex == 0">
            {{ item.sku }}
          </div>
          <div class="GoodsForEmployee_goods-item-activity">
            <span class="GoodsForEmployee_goods-item-activity-text"
              >员工内购价:￥</span
            >
            <span class="GoodsForEmployee_goods-item-activity-price">{{
              item.price
            }}</span>
          </div>
          <div class="GoodsForEmployee_goods-item-original">
            原价：￥{{ item.original }}
          </div>
        </div>
        <span class="GoodsForEmployee_goods-item-buy"></span>
      </div>
    </div>
    <div class="GoodsForEmployee_scroll-top" @click="toTop"></div>
  </div>
</template>
<script>
const baseUrl = "https://zhongsheng-prod-beijing.oss-cn-beijing.aliyuncs.com/web/";
import { toGoodsDetail } from "../utils/InteractionWithJs";
import { addLog } from "../utils/commonApi";
import { getUrlQueryValueByKey } from "@/utils/util";
export default {
  data() {
    return {
      tabList: ["酒水米面", "潮玩手办", "星际熊"],
      selectIndex: localStorage.getItem("ngCurrentTab") || 0,
      goods: [
        [
          {
            name: "鸭绿江精品越光米",
            sku: "5kg/箱",
            price: "80",
            original: "180",
            img: `${baseUrl}72f7fe22637f8c91.png`,
            id: "10846123",
          },
          {
            name: "河套雪花粉",
            sku: "2.5kg/袋",
            price: "50",
            original: "63.8",
            img: `${baseUrl}ae42465aa1eee55f.png`,
            id: "10876426",
          },
          {
            name: "亿斯低氘冰川水",
            sku: "340ml×24瓶/箱",
            price: "83",
            original: "238",
            img: `${baseUrl}4b450f7ea9b8ea17.png`,
            id: "10555016",
          },
          {
            name: "大红袍茶梅见",
            sku: "750ml/瓶",
            price: "198",
            original: "398",
            img: `${baseUrl}1fc5c48f0b3077bc.png`,
            id: "10875195",
          },
          {
            name: "10年陈皮梅见",
            sku: "750ml/瓶",
            price: "198",
            original: "408",
            img: `${baseUrl}b1e3012b434fadcb.png`,
            id: "10875205",
          },
          {
            name: "15年陈皮梅见",
            sku: "750ml/瓶",
            price: "248",
            original: "508",
            img: `${baseUrl}dec3e7226306ab22.png`,
            id: "10875206",
          },
          {
            name: "三年坛陈梅见",
            sku: "700ml/瓶",
            price: "310",
            original: "598",
            img: `${baseUrl}188c879684e5a739.png`,
            id: "10878053",
          },
          {
            name: "拉蒙(欢庆)葡萄酒",
            sku: "750ml/瓶",
            price: "120",
            original: "429",
            img: `${baseUrl}fe51bfffd80aaf0f.png`,
            id: "10554829",
          },
          {
            name: "拉蒙(献礼)葡萄酒",
            sku: "750ml/瓶",
            price: "130",
            original: "466",
            img: `${baseUrl}dd13eba845d5fd57.png`,
            id: "10554843",
          },
          {
            name: "拉蒙(盛宴)葡萄酒",
            sku: "750ml/瓶",
            price: "160",
            original: "529",
            img: `${baseUrl}be1d0ce1d476269e.png`,
            id: "10554842",
          },
          {
            name: "拉蒙(权杖)葡萄酒",
            sku: "750ml/瓶",
            price: "190",
            original: "588",
            img: `${baseUrl}d2bf4ce83d6f42b7.png`,
            id: "10554828",
          },
          {
            name: "拉蒙(欢庆)葡萄酒",
            sku: "750ml*6瓶/箱",
            price: "670",
            original: "2574",
            img: `${baseUrl}7d8da1fb80cf1cce.png`,
            id: "10554845",
          },
          {
            name: "拉蒙(献礼)葡萄酒",
            sku: "750ml*6瓶/箱",
            price: "730",
            original: "2796",
            img: `${baseUrl}3c6149fdbebc8abe.png`,
            id: "10554847",
          },
          {
            name: "拉蒙(盛宴)葡萄酒",
            sku: "750ml*6瓶/箱",
            price: "910",
            original: "3174",
            img: `${baseUrl}df15071d21af2546.png`,
            id: "10554846",
          },
          {
            name: "拉蒙(权杖)葡萄酒",
            sku: "750ml*6瓶/箱",
            price: "1090",
            original: "3528",
            img: `${baseUrl}cf4b5267852c1804.png`,
            id: "10554844",
          },
          {
            name: "罗曼湖7年威士忌",
            sku: "700ml/瓶",
            price: "300",
            original: "880",
            img: `${baseUrl}f12c5832aacd724d.png`,
            id: "10875760",
          },
          {
            name: "罗曼湖14年威士忌",
            sku: "700ml/瓶",
            price: "640",
            original: "1058",
            img: `${baseUrl}8accf76514be3e01.png`,
            id: "10875713",
          },
          {
            name: "罗曼湖21年威士忌",
            sku: "700ml/瓶",
            price: "2400",
            original: "4066",
            img: `${baseUrl}c6bfde2a66f58c2c.png`,
            id: "10875714",
          },
          {
            name: "格兰帝15年威士忌",
            sku: "700ml/瓶",
            price: "700",
            original: "1226",
            img: `${baseUrl}2ee9caf89f7c9cf0.png`,
            id: "10875762",
          },
          {
            name: "格兰帝18年威士忌",
            sku: "700ml/瓶",
            price: "1200",
            original: "1990",
            img: `${baseUrl}ccfcd8fbcc93aa33.png`,
            id: "10875763",
          },
          {
            name: "格兰帝25年威士忌",
            sku: "700ml/瓶",
            price: "6000",
            original: "12888",
            img: `${baseUrl}6e11a8ac17a12d0a.png`,
            id: "10875764",
          },
          {
            name: "罗曼湖30年威士忌",
            sku: "700ml/瓶",
            price: "7000",
            original: "11888",
            img: `${baseUrl}a5b0550c6dc8ea84.png`,
            id: "10875761",
          },
        ],
        [
          {
            name: "机动奥特曼艾斯B",
            price: "814",
            original: "1088",
            img: `${baseUrl}0a10f3eebebc971c.png`,
            id: "10844352",
          },
          {
            name: "超巨大迪迦奥特曼声光人偶",
            price: "492",
            original: "699",
            img: `${baseUrl}5cadb7256ed7184a.png`,
            id: "10843384",
          },
          {
            name: "超巨大泽塔奥特曼声光人偶",
            price: "492",
            original: "699",
            img: `${baseUrl}ff163e363450970a.png`,
            id: "10843960",
          },
          {
            name: "欧布奥特曼重光形态声光人偶",
            price: "492",
            original: "699",
            img: `${baseUrl}c402a1a9da10fa0a.png`,
            id: "10843873",
          },
          {
            name: "机动奥特曼百慕拉",
            price: "964",
            original: "1288",
            img: `${baseUrl}843bf41e98883ae6.png`,
            id: "10844494",
          },
          {
            name: "机动奥特曼艾斯A",
            price: "644",
            original: "920",
            img: `${baseUrl}1df514aeee6d8ada.png`,
            id: "10844191",
          },
          {
            name: "机动奥特曼泰罗",
            price: "720",
            original: "960",
            img: `${baseUrl}a79b268a542f1d11.png`,
            id: "10875439",
          },
          {
            name: "银河奥特曼声光人偶",
            price: "492",
            original: "699",
            img: `${baseUrl}b2c4cac000a97275.png`,
            id: "10844049",
          },
          {
            name: "超大路飞毛绒公仔",
            price: "378",
            original: "788",
            img: `${baseUrl}1383664283d5e7d2.png`,
            id: "10875434",
          },
          {
            name: "OP国风索隆手办",
            price: "4485",
            original: "5980",
            img: `${baseUrl}6365ecf2dce2f872.png`,
            id: "10844620",
          },
          {
            name: "OP骑牛路飞手办",
            price: "3285",
            original: "4380",
            img: `${baseUrl}b1a1d2ccd5f47895.png`,
            id: "10844673",
          },
          {
            name: "KT半机械手办-绿",
            price: "642",
            original: "988",
            img: `${baseUrl}c97e696f75987c2b.png`,
            id: "10845626",
          },
          {
            name: "龙珠布尔玛手办",
            price: "3966",
            original: "5288",
            img: `${baseUrl}e22abf99e5e9f9e9.png`,
            id: "10845529",
          },
          {
            name: "进击的巨人手办",
            price: "6666",
            original: "8888",
            img: `${baseUrl}410f17eb726996bc.png`,
            id: "10845453",
          },
        ],
        [
          {
            name: "超能星舰系列-坦克",
            price: "3184",
            original: "4899",
            img: `${baseUrl}cc095f1f040f8268.png`,
            id: "10877261",
          },
          {
            name: "幻彩糖果系列-红色",
            price: "2209",
            original: "3399",
            img: `${baseUrl}8f65d1298fdc7425.png`,
            id: "10877182",
          },
          {
            name: "彩绘系列-彩色",
            price: "2209",
            original: "3399",
            img: `${baseUrl}192af9fcec0d6476.png`,
            id: "10877183",
          },
          {
            name: "幻彩糖果系列-幻彩紫",
            price: "2209",
            original: "3399",
            img: `${baseUrl}a75d279448de4318.png`,
            id: "10877180",
          },
          {
            name: "设计师收藏版-黑色",
            price: "2209",
            original: "3399",
            img: `${baseUrl}dd4aaf43bab79599.png`,
            id: "10877184",
          },
          {
            name: "电镀拼色系列-橙色",
            price: "1949",
            original: "2999",
            img: `${baseUrl}66668209c1474969.png`,
            id: "10877177",
          },
          {
            name: "电镀拼色系列-绿色",
            price: "1949",
            original: "2999",
            img: `${baseUrl}8826e262004e506a.png`,
            id: "10877176",
          },
          {
            name: "缤纷印花系列-白色",
            price: "1949",
            original: "2999",
            img: `${baseUrl}6ec8790842490b68.png`,
            id: "10877259",
          },
          {
            name: "甲骨文系列-黑色",
            price: "1949",
            original: "2999",
            img: `${baseUrl}3f3326585d8b7873.png`,
            id: "10877258",
          },
          {
            name: "电镀纯色系列-金色",
            price: "1754",
            original: "2699",
            img: `${baseUrl}bfc6fa2aa3b69427.png`,
            id: "10877169",
          },
          {
            name: "电镀纯色系列-银色",
            price: "1754",
            original: "2699",
            img: `${baseUrl}e5b57259ded1093c.png`,
            id: "10877173",
          },
          {
            name: "电镀纯色系列-枪色",
            price: "1754",
            original: "2699",
            img: `${baseUrl}f4cbcf256b9b3154.png`,
            id: "10877171",
          },
          {
            name: "电镀纯色系列-天蓝",
            price: "1754",
            original: "2699",
            img: `${baseUrl}6d9070cefb10d31a.png`,
            id: "10877174",
          },
          {
            name: "电镀纯色系列-蓝色",
            price: "1754",
            original: "2699",
            img: `${baseUrl}1287f7e3d786bdce.png`,
            id: "10877170",
          },
          {
            name: "电镀纯色系列-桃红",
            price: "1754",
            original: "2699",
            img: `${baseUrl}53e92a5d2f1ba4bd.png`,
            id: "10877172",
          },
          {
            name: "幻彩糖果系列-幻彩紫",
            price: "1299",
            original: "1999",
            img: `${baseUrl}26ccfa78c1cecd7a.png`,
            id: "10877180",
          },
          {
            name: "幻彩糖果系列-幻彩蓝",
            price: "1299",
            original: "1999",
            img: `${baseUrl}1312a2a8743f1b9b.png`,
            id: "10877181",
          },
          {
            name: "幻彩糖果系列-幻彩白",
            price: "1299",
            original: "1999",
            img: `${baseUrl}f8190a92e45ebc22.png`,
            id: "10877179",
          },
          {
            name: "幻彩糖果系列-幻彩红",
            price: "1299",
            original: "1999",
            img: `${baseUrl}90c06ab45aec4619.png`,
            id: "10877182",
          },
          {
            name: "工业重金属系列-枪色",
            price: "1104",
            original: "1699",
            img: `${baseUrl}71af5967f603d888.png`,
            id: "10877265",
          },
          {
            name: "工业重金属系列-哑银",
            price: "1104",
            original: "1699",
            img: `${baseUrl}9b9ffc470cad97c5.png`,
            id: "10877263",
          },
          {
            name: "工业重金属系列-玫瑰金",
            price: "1104",
            original: "1699",
            id: "10877535",
            img: `${baseUrl}211eebbccde5f441.png`,
          },
          {
            name: "工业重金属系列-金色",
            price: "1104",
            original: "1699",
            id: "10877264",
            img: `${baseUrl}d1da8600926c419e.png`,
          },
          {
            name: "工业重金属系列-玫瑰金+叻色",
            price: "1104",
            original: "1699",
            id: "10877262",
            img: `${baseUrl}10ec3c0395d178f5.png`,
          },
          {
            name: "电镀渐变系列-幻彩",
            price: "1104",
            original: "1699",
            id: "10877175",
            img: `${baseUrl}13c5f31270a975a2.png`,
          },
        ],
      ],
    };
  },
  mounted() {
    document.title = "员工内购专享";
    console.log(localStorage.getItem("ngCurrentTab"))
    addLog(
      getUrlQueryValueByKey(location.href, "accessRefer") || "",
      "23-11-5",
      ""
    );
  },
  methods: {
    handleTabClick(index) {
      this.selectIndex = index;
      localStorage.setItem("ngCurrentTab", index);
    },
    toTop() {
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
    },
    handleBuyClick(id) {
      toGoodsDetail(0, id);
      // console.log(localStorage.getItem("currentTab"))
    },
  },
};
</script>

<style scoped>
.GoodsForEmployee_container {
  display: flex;
  width: 100vw;
  min-height: 100vh;
  flex-direction: column;
  align-items: center;
  background-color: #ef3f69;
}

.GoodsForEmployee_logo {
  width: 100%;
  height: 7.8rem;
  background-image: url(https://zhongsheng-prod-beijing.oss-cn-beijing.aliyuncs.com/web/291edcc88be9b0af.png);
  background-size: 100% auto;
  /* background-position-y: bottom; */
}

.GoodsForEmployee_tab-list {
  width: 6.9rem;
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-top: -1.6rem;
}

.GoodsForEmployee_tab-item {
  flex: 1;
  width: 2.3rem;
  height: 0.7rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-top-left-radius: 0.1rem;
  border-top-right-radius: 0.1rem;
}

.GoodsForEmployee_tab-list > div:nth-child(2) {
  margin: 0 0.1rem;
}

.GoodsForEmployee_tab-item-unactive {
  background: #cf3358;
  color: #ffffff;
  font-weight: bolder;
}

.GoodsForEmployee_tab-item-active {
  background: #ffffff;
  color: #ef4068;
  font-weight: bolder;
}

.GoodsForEmployee_goods-list {
  width: 6.9rem;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  background: #ffffff;
  padding-top: 0.4rem;
  /* justify-content: space-between; */
  /* padding: 0 0.05rem; */
}

.GoodsForEmployee_goods-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 0.04rem;
}

.GoodsForEmployee_goods-item-info {
  width: 2.22rem;
  height: 2.82rem;
  background-size: 100% auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
}

.GoodsForEmployee_goods-item-img {
  width: 2.22rem;
  position: absolute;
  top: 0;
  left: 0;
}

.GoodsForEmployee_goods-item-name {
  font-size: 0.26rem;
  color: #010101;
  font-weight: bolder;
  width: 95%;
  z-index: 1;
  margin-top: 1.55rem;
  letter-spacing: -0.02rem;
  text-align: left;
  /* width: 100%; */
}

.one-line {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.two-line {
  height: 0.6rem;
  line-height: 0.3rem;
}

.GoodsForEmployee_goods-item-sku {
  width: 95%;
  text-align: left;
  font-size: 0.18rem;
  color: #010101;
  z-index: 1;
}

.GoodsForEmployee_goods-item-activity {
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  width: 95%;
  z-index: 1;
}

.GoodsForEmployee_goods-item-activity-text {
  color: #bb1c22;
  font-size: 0.2rem;
  z-index: 1;
}

.GoodsForEmployee_goods-item-activity-price {
  color: #bb1c22;
  font-size: 0.35rem;
  font-weight: bolder;
  line-height: 1;
  z-index: 1;
  letter-spacing: -0.02rem;
}

.GoodsForEmployee_goods-item-original {
  font-size: 0.2rem;
  color: #a0a0a0;
  width: 95%;
  text-align: left;
  z-index: 1;
  margin-top: -0.05rem;
}

.GoodsForEmployee_goods-item-buy {
  width: 1.17rem;
  height: 0.47rem;
  background-image: url(https://zhongsheng-prod-beijing.oss-cn-beijing.aliyuncs.com/web/1ef519986a7e7454.png);
  background-size: 100% auto;
  background-repeat: no-repeat;
  margin-top: 0.1rem;
  margin-bottom: 0.3rem;
}

.GoodsForEmployee_scroll-top {
  width: 2.61rem;
  height: 3.16rem;
  background-image: url(https://zhongsheng-prod-beijing.oss-cn-beijing.aliyuncs.com/web/f2733a497ef92ea1.png);
  background-size: 100% auto;
  background-repeat: no-repeat;
  margin: 0.2rem 0 0.9rem;
}
</style>
